import { usePunditUserContext } from "@/react/contexts/punditUserContext";

export const useIsListSystemTemplatesEnabled = () => {
  const { currentCommunitySettings } = usePunditUserContext();
  return Boolean(currentCommunitySettings?.visual_email_builder_enabled);
};
